import { render, staticRenderFns } from "./Abusives.vue?vue&type=template&id=06f3ab7e&scoped=true"
import script from "./Abusives.vue?vue&type=script&lang=js"
export * from "./Abusives.vue?vue&type=script&lang=js"
import style0 from "./Abusives.vue?vue&type=style&index=0&id=06f3ab7e&prod&lang=css"
import style1 from "./Abusives.vue?vue&type=style&index=1&id=06f3ab7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f3ab7e",
  null
  
)

export default component.exports